import { CancelIconButton, Grid, Stack, Tooltip, Typography, useElementBreakpoints } from "@compass/core";
import { BulkSelectedItemErrors } from "generated/openApi";
import { memo } from "react";

export const BulkSelectedItems = memo(
  <T extends { id: number }>(props: {
    gridView: boolean;
    items: Map<any, T>; // Changed Map<number, T> to Map<any, T>
    getItemLabel: (item: T) => string;
    onRemove: (id: number) => void;
    errors: BulkSelectedItemErrors[];
    errorFilter: boolean;
  }) => {
    const { breakpointsRef, setBreakpoints } = useElementBreakpoints();

    const getItemErrors = (errors: string[], toolTip?: boolean) => {
      return (
        <>
          {errors.map((y, index) => {
            return (
              <Typography key={index} color={toolTip ? undefined : "error"} variant="caption">
                {errors.length > 1 ? index + 1 + ". " : ""}
                {y}
              </Typography>
            );
          })}
        </>
      );
    };

    return (
      <Grid ref={breakpointsRef} container spacing="xs">
        {Array.from(props.items).map(([key, item]) => {
          const errors = props.errors.find((x) => x.id === item.id)?.errors || [];
          const hasErrors = errors.length > 0;
          if (props.errorFilter && !hasErrors) return null;

          return (
            <Grid 
              key={key} 
              item 
              xs={props.gridView ? setBreakpoints({ lg: 3, md: 4, sm: 6, xs: 12 }) : 12}
            >
              <Tooltip
                title={props.gridView && hasErrors ? getItemErrors(errors, true) : ""}
                color="error"
                sx={{ width: "100%" }}
              >
                <Stack
                  width="100%"
                  direction="row"
                  spacing="md"
                  border={1}
                  borderColor={(theme) => (hasErrors ? theme.palette.error.dark : theme.palette.border.dark)}
                  alignItems="center"
                  justifyContent={"space-between"}
                  p={0.5}
                  sx={{
                    "&:not(:last-child)": {
                      borderBottom: "0", 
                    },
                  }}
                >
                  <Stack direction="row" spacing="xs" alignItems="center" flexShrink={0}>
                    <CancelIconButton onClick={() => props.onRemove(item.id)} />
                    <Stack>{props.getItemLabel(item)}</Stack>
                  </Stack>

                  {!props.gridView && <Stack alignItems="flex-end">{getItemErrors(errors)}</Stack>}
                </Stack>
              </Tooltip>
            </Grid>
          );
        })}
      </Grid>
    );
  }
);